export default __webpack_public_path__ + "static/media/4.a44c2467.svg";